import React, { useState } from "react"

import { LinearProgress, Stack, Typography } from "@mui/material"
import Grid2 from "@mui/material/Grid2"
import TicketForm from "../TicketForm"
import TicketsTable from "../TicketsTable"
import { useParams } from "react-router-dom"

const RaffleTickets = ({ raffle }: { raffle?: any } = {}) => {
  const { id: raffleId } = useParams()
  const [loading, setLoading] = useState(false)

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <TicketForm
            raffleId={raffleId}
            onSuccess={() => {
              setLoading(true)

              setTimeout(() => {
                setLoading(false)
              }, 1000)
            }}
          />
        </Grid2>
        <Grid2 size={12}>
          {loading ? (
            <Stack spacing={1.5} sx={{ px: 1 }}>
              <Typography variant="body2" color="text.secondary">
                Refreshing ticket list...
              </Typography>
              <LinearProgress />
            </Stack>
          ) : (
            <TicketsTable raffleId={raffleId} raffle={raffle} />
          )}
        </Grid2>
      </Grid2>
    </>
  )
}

export default RaffleTickets
